// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19 1H5V23H19V1ZM13.0039 17V19.0039H11V17H13.0039Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M4 19L4 5H2V19H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 19V5H20V19H22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mobile-vibrate-filled')
export default class MobileVibrateFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mobile-vibrate-filled',
    }
  }
}
